import { render, staticRenderFns } from "./TherapyPortalPage.vue?vue&type=template&id=1d3ae0cc"
import script from "./TherapyPortalPage.vue?vue&type=script&lang=js"
export * from "./TherapyPortalPage.vue?vue&type=script&lang=js"
import style0 from "./TherapyPortalPage.vue?vue&type=style&index=0&id=1d3ae0cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports